import { render, staticRenderFns } from "./InputFile.vue?vue&type=template&id=3cfc2b20&scoped=true&"
import script from "./InputFile.vue?vue&type=script&lang=ts&"
export * from "./InputFile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfc2b20",
  null
  
)

export default component.exports